import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { QueryHighlightModel } from './models/query-highlight-model';
import { QueryHighlightModelImpl } from './models/impls/query-highlight-model';
import { QueryHighlightService } from './services/query-highlight-service';
import { QueryHighlightServiceImpl } from './services/impls/query-highlight-service';
import { CustomHighlightModel } from './models/custom-highlight-model';
import { CustomHighlightModelImpl } from './models/impls/custom-highlight-model';
import { CustomHighlightService } from './services/custom-highlight-service';
import { CustomHighlightServiceImpl } from './services/impls/custom-highlight-service';

export const highlightModule = (bind: interfaces.Bind) => {
    bind(QueryHighlightModel).to(QueryHighlightModelImpl);
    bind(QueryHighlightService).to(QueryHighlightServiceImpl);
    bind(CustomHighlightModel).to(CustomHighlightModelImpl);
    bind(CustomHighlightService).to(CustomHighlightServiceImpl);
};
